import React, { Fragment } from "react";
import { Box, Typography } from "@material-ui/core";
import ReplyIcon from "Assets/images/message-icons/reply-gray.svg";
import moment from "moment";
import { KENDO_DATE_FORMAT } from "src/constants";
import UserProfileWidget from "Components/widgets/UserProfileWidget";
import { get } from "lodash";
const ReplyThread = ({ commentThread }) => {
  return (
    <Fragment>
      {commentThread.map((res, key) => (
        <Box>
          <Box display="flex" ml={3} mt={2} key={key} alignItems="start">
            <img src={ReplyIcon} alt="Reply" className="pt5" />
            <Box ml={1}>
              <Box display="flex">
                <UserProfileWidget
                  firstName={get(res, "createdBy.firstName", "")}
                  lastName={get(res, "createdBy.lastName", "")}
                  url={get(res, "createdBy.profileImage.fileName", "")}
                />
                <Box className="ml5">
                  <Typography variant="body2" className="font-12 font-semibold">
                    {get(res, "createdBy.firstName", "")}{" "}
                    {get(res, "createdBy.lastName", "")}
                  </Typography>
                  <Typography variant="body2" className="font-11 f-light-gray">
                    {get(res, "createdBy.department", "")}
                  </Typography>
                </Box>
              </Box>
              <Box>
                <Typography variant="body2" className="font-12">
                  {res.comment}
                </Typography>
                <Typography variant="body2" className="f-light-gray font-12">
                  {moment(res.createdAt).format(KENDO_DATE_FORMAT)}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      ))}
    </Fragment>
  );
};

export default ReplyThread;
